import { z } from 'zod';

import type { AddonOnboardingConfig } from '../types';

/**
 * Build a zod schema at runtime from an onboarding config's form-step fields.
 *
 * Field names are unique across the flow, so a single schema/form instance
 * covers every form step; the wizard validates a given step by triggering only
 * that step's field names. Keeps configs as pure data (the trade-off is that
 * values are typed as `Record<string, string>` rather than per-field types).
 */
export function buildOnboardingSchema(config: AddonOnboardingConfig) {
  const shape: Record<string, z.ZodString> = {};

  for (const step of config.steps) {
    if (step.kind !== 'form') continue;
    for (const field of step.form.fields) {
      let schema = z.string();
      if (field.type === 'email') {
        schema = schema.email('Enter a valid email address');
      }
      if (field.required) {
        schema = schema.min(1, `${field.label} is required`);
      }
      shape[field.name] = schema;
    }
  }

  return z.object(shape);
}
